var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebreakBricksSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 47,
    viewBox: "0 0 390 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 234.766 24.5264)",
    fill: "#FF2A02"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 358.449 24.5264)",
    fill: "#FF2A02"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 276.062 24.5264)",
    fill: "#FF2A02"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 317.359 24.5264)",
    fill: "#FF2A02"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 248.602 24.5264)",
    fill: "#FF2A02"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 372.283 24.5264)",
    fill: "#FF2A02"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 289.689 24.5264)",
    fill: "#FF2A02"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 330.986 24.5264)",
    fill: "#FF2A02"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 262.227 24.5264)",
    fill: "#FF2A02"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 385.91 24.5264)",
    fill: "#FF2A02"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 303.525 24.5264)",
    fill: "#FF2A02"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 344.613 24.5264)",
    fill: "#FF2A02"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 110.686 24.5264)",
    fill: "#FF2A02"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 28.2988 24.5264)",
    fill: "#FF2A02"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 151.98 24.5264)",
    fill: "#FF2A02"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 69.5957 24.5264)",
    fill: "#FF2A02"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 193.07 24.5264)",
    fill: "#FF2A02"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 0.837891 24.5264)",
    fill: "#FF2A02"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 124.52 24.5264)",
    fill: "#FF2A02"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 41.9238 24.5264)",
    fill: "#FF2A02"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 165.607 24.5264)",
    fill: "#FF2A02"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 83.2227 24.5264)",
    fill: "#FF2A02"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 206.904 24.5264)",
    fill: "#FF2A02"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 14.4629 24.5264)",
    fill: "#FF2A02"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 138.146 24.5264)",
    fill: "#FF2A02"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 55.7617 24.5264)",
    fill: "#FF2A02"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 179.441 24.5264)",
    fill: "#FF2A02"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 96.8477 24.5264)",
    fill: "#FF2A02"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 220.74 24.5264)",
    fill: "#FF2A02"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 240.635 0)",
    fill: "#FF2A02"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 364.316 0.000976562)",
    fill: "#FF2A02"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 281.932 0)",
    fill: "#FF2A02"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 323.23 0.000976562)",
    fill: "#FF2A02"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 254.471 0.000976562)",
    fill: "#FF2A02"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 378.154 0.000976562)",
    fill: "#FF2A02"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 295.559 0.000976562)",
    fill: "#FF2A02"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 336.855 0)",
    fill: "#FF2A02"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 268.096 0.000976562)",
    fill: "#FF2A02"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 309.393 0.000976562)",
    fill: "#FF2A02"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 350.482 0.000976562)",
    fill: "#FF2A02"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 -7.12891 0.000976562)",
    fill: "#FF2A02"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 116.553 0)",
    fill: "#FF2A02"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 34.168 0.000976562)",
    fill: "#FF2A02"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 157.852 0.000976562)",
    fill: "#FF2A02"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 75.4648 0.000976562)",
    fill: "#FF2A02"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 198.939 0)",
    fill: "#FF2A02"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 6.70508 0.000976562)",
    fill: "#FF2A02"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 130.389 0.000976562)",
    fill: "#FF2A02"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 47.7949 0.000976562)",
    fill: "#FF2A02"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 171.477 0)",
    fill: "#FF2A02"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 89.0918 0.000976562)",
    fill: "#FF2A02"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 212.773 0)",
    fill: "#FF2A02"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 20.332 0)",
    fill: "#FF2A02"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 144.016 0.000976562)",
    fill: "#FF2A02"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 61.6289 0.000976562)",
    fill: "#FF2A02"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 185.312 0.000976562)",
    fill: "#FF2A02"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.7394,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 102.717 0.000976562)",
    fill: "#FF2A02"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 22.221,
    height: 11.5298,
    rx: 2,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 226.609 0.000976562)",
    fill: "#FF2A02"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebreakBricksSmall);
export default __webpack_public_path__ + "static/media/firebreak_bricks_small.5e03fe0e5e175aad6c0d1fa3b07e86fb.svg";
export { ForwardRef as ReactComponent };